import { BaseIllustration, BaseIllustrationProps } from '../BaseIllustration';

export type SearchContentIllustrationProps = Omit<BaseIllustrationProps, 'children'>;

export const SearchContentIllustration = ({ ...props }: SearchContentIllustrationProps) => (
  <BaseIllustration width="64" height="64" viewBox="0 0 64 64" {...props}>
    <g strokeWidth={2} strokeLinecap="square" fill="none">
      <line x1="22" x2="4" y1="24" y2="24" />
      <line x1="22" x2="4" y1="40" y2="40" />
      <line x1="42" x2="4" y1="56" y2="56" />
      <line x1="42" x2="4" y1="8" y2="8" />
      <circle cx="42" cy="32" r="12" />
      <line x1="60" x2="50.485" y1="50" y2="40.485" />
    </g>
  </BaseIllustration>
);

SearchContentIllustration.displayName = 'SearchContentIllustration';
